import * as React from "react";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import {
  DataGrid,
  Toolbar,
  ToolbarButton,
  ColumnsPanelTrigger,
  FilterPanelTrigger,
  //   ExportCsv,
  //   ExportPrint,
  QuickFilter,
  QuickFilterControl,
  QuickFilterClear,
  QuickFilterTrigger,
} from "@mui/x-data-grid";
import Pagination from "@mui/material/Pagination";
import PaginationItem from "@mui/material/PaginationItem";
import Typography from "@mui/material/Typography";
import Tooltip from "@mui/material/Tooltip";
import Badge from "@mui/material/Badge";
import ViewColumnIcon from "@mui/icons-material/ViewColumn";
import FilterListIcon from "@mui/icons-material/FilterList";
// import FileDownloadIcon from '@mui/icons-material/FileDownload';
// import MenuItem from '@mui/material/MenuItem';
import Divider from "@mui/material/Divider";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import CancelIcon from "@mui/icons-material/Cancel";
import SearchIcon from "@mui/icons-material/Search";
// import Typography from "@mui/material/Typography";
import { useNavigate } from "react-router-dom";
// import { UserRoles, Statuses } from "../../components/common/constant";
import { useParams, generatePath } from "react-router-dom";
import Button from "@mui/material/Button";
import HistoryIcon from '@mui/icons-material/History'; 
import { UserRoles, Statuses } from "../../components/common/constant";
[];
function CustomToolbar({ allSelected, onApproveAll, showSelectAll }) {
  //   const [exportMenuOpen, setExportMenuOpen] = React.useState(false);
  //   const exportMenuTriggerRef = React.useRef(null);
  const StyledQuickFilter = styled(QuickFilter)({
    display: "grid",
    alignItems: "center",
  });
  const StyledToolbarButton = styled(ToolbarButton)(
    ({ theme, ownerState }) => ({
      gridArea: "1 / 1",
      width: "min-content",
      height: "min-content",
      zIndex: 1,
      opacity: ownerState.expanded ? 0 : 1,
      pointerEvents: ownerState.expanded ? "none" : "auto",
      transition: theme.transitions.create(["opacity"]),
    })
  );

  const StyledTextField = styled(TextField)(({ theme, ownerState }) => ({
    gridArea: "1 / 1",
    overflowX: "clip",
    width: ownerState.expanded ? 260 : "var(--trigger-width)",
    opacity: ownerState.expanded ? 1 : 0,
    transition: theme.transitions.create(["width", "opacity"]),
  }));
  return (
    <Toolbar
      variant="dense"
      disableGutters
      sx={
        {
          // '@media (min-width: 600px)': {
          //    minHeight: '70px',
          // },
          // minHeight: '70px',
          // marginLeft: "10px",
          // marginTop: "10px"
        }
      }
    >
      {showSelectAll && (
        <Tooltip sx={{ flex: "1 1 100%" }} title={"Approve All Doors"}>
          <Button
            variant="contained"
            className="justifyStart btn btn-primary"
            size="medium"
            style={{ minHeight: "auto" }}
            onClick={onApproveAll}
            sx={{ marginRight: 2, textTransform: "none" }}
            disabled={!allSelected}
          >
            {"Approve All Doors"}
          </Button>
        </Tooltip>
      )}
      {showSelectAll && (
        <Divider
          orientation="vertical"
          variant="middle"
          flexItem
          sx={{ mx: 0.5 }}
        />
      )}

      <Tooltip title="Columns">
        <ColumnsPanelTrigger render={<ToolbarButton />}>
          <ViewColumnIcon fontSize="small" />
        </ColumnsPanelTrigger>
      </Tooltip>

      <Tooltip title="Filters">
        <FilterPanelTrigger
          render={(props, state) => (
            <ToolbarButton {...props} color="default">
              <Badge
                badgeContent={state.filterCount}
                color="primary"
                variant="dot"
              >
                <FilterListIcon fontSize="small" />
              </Badge>
            </ToolbarButton>
          )}
        />
      </Tooltip>

      <Divider
        orientation="vertical"
        variant="middle"
        flexItem
        sx={{ mx: 0.5 }}
      />

      <StyledQuickFilter>
        <QuickFilterTrigger
          render={(triggerProps, state) => (
            <Tooltip title="Search" enterDelay={0}>
              <StyledToolbarButton
                {...triggerProps}
                ownerState={{ expanded: state.expanded }}
                color="default"
                aria-disabled={state.expanded}
              >
                <SearchIcon fontSize="small" />
              </StyledToolbarButton>
            </Tooltip>
          )}
        />
        <QuickFilterControl
          render={({ ref, ...controlProps }, state) => (
            <StyledTextField
              {...controlProps}
              ownerState={{ expanded: state.expanded }}
              inputRef={ref}
              aria-label="Search"
              placeholder="Search..."
              size="small"
              slotProps={{
                input: {
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon fontSize="small" />
                    </InputAdornment>
                  ),
                  endAdornment: state.value ? (
                    <InputAdornment position="end">
                      <QuickFilterClear
                        edge="end"
                        size="small"
                        aria-label="Clear search"
                        material={{ sx: { marginRight: -0.75 } }}
                      >
                        <CancelIcon fontSize="small" />
                      </QuickFilterClear>
                    </InputAdornment>
                  ) : null,
                  ...controlProps.slotProps?.input,
                },
                ...controlProps.slotProps,
              }}
            />
          )}
        />
      </StyledQuickFilter>
    </Toolbar>
  );
}

const gridStyles = {
  "& .MuiDataGrid-columnHeaders": {
    backgroundColor: "#1976d2", // 🔵 Deep blue header
    color: "#ffffff", // ⚪ White text
    fontWeight: "bold",
    fontSize: "0.95rem",
  },
  // Optional: Add border or shadow for extra flair
  //   "& .MuiDataGrid-columnHeader": {
  //     borderRight: "1px solid #e0e0e0",
  //   },

  "& .MuiDataGrid-row:nth-of-type(even)": {
    backgroundColor: "#F2F5FA",
    borderBottom: "1px solid #E5E7EB",
  },
  "& .MuiDataGrid-row:nth-of-type(odd)": {
    backgroundColor: "#ffffff",
    borderBottom: "1px solid #E5E7EB",
  },
  "& .MuiDataGrid-row": {
    color: "#18181B",
    fontWeight: "500",
    fontSize: "16px",
    lineHeight: "20px",
    verticalAlign: "middle",
  },
};

function CustomPagination({ rowCount = 0, page, pageSize, onPageChange }) {
  const pageCount = Math.ceil(rowCount / pageSize) || 1;

  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      p={2}
    >
      <Typography variant="body2">
        {rowCount > 0
          ? `Showing ${page * pageSize + 1} to ${Math.min(
              (page + 1) * pageSize,
              rowCount
            )} of ${rowCount} results`
          : "No results"}
      </Typography>

      <Pagination
        count={pageCount}
        page={page + 1} // DataGrid is 0-based, Pagination is 1-based
        onChange={(event, value) => onPageChange(value - 1)}
        color="primary"
        shape="rounded"
        siblingCount={1}
        boundaryCount={1}
        renderItem={(item) => (
          <PaginationItem
            {...item}
            slots={{
              previous: () => <>Previous</>,
              next: () => <>Next</>,
            }}
          />
        )}
      />
    </Box>
  );
}

export default function DataGridTable(props) {
  const [page, setPage] = React.useState(0);
  const [loading, setLoading] = React.useState(true);
  const [userList, setUserList] = React.useState([]);
  const [filterModel, setFilterModel] = React.useState({ items: [] });
  const [selectedRows, setSelectedRows] = React.useState([]);
  const { tableData, pageSize } = props;
  const { clientNameParam, propertyMasterId, inspectionRefnumber } =
    useParams();
  const RequestForChange = tableData.filter(
    (x) => x.status === Statuses.REQUESTFORCHANGE
  );
  const isRequestForChange = RequestForChange.length > 0 ? true : false;

  React.useEffect(() => {
    setLoading(true);
    const payload = tableData?.map((item, index) => {
      return {
        id: index + 1,
        ...item,
      };
    });
    setUserList(payload);
    setLoading(false);
  }, [tableData]);
  const navigate = useNavigate();
  const gotoDashBoard = (drn, field) => {
    let pathTemplate;
    if (field === "view") {
      pathTemplate =
        "/client/:clientNameParam/viewSurvey/:propertyMasterId/:inspectionRefnumber/:doorRefNumber";
    } else {
      pathTemplate =
        "/client/:clientNameParam/editSurvey/:propertyMasterId/:inspectionRefnumber/:doorRefNumber";
    }
    const params = {
      clientNameParam: clientNameParam,
      propertyMasterId: propertyMasterId,
      inspectionRefnumber: inspectionRefnumber,
      doorRefNumber: drn,
    };

    const fullPath = generatePath(pathTemplate, params);
    navigate(fullPath);
  };

  const gotoAuditScreen = (drn) => {
    const pathTemplate =
      "/client/:clientNameParam/AuditTrail/:propertyMasterId/:inspectionRefnumber/:doorRefNumber";

    const params = {
      clientNameParam: clientNameParam,
      propertyMasterId: propertyMasterId,
      inspectionRefnumber: inspectionRefnumber,
      doorRefNumber: drn,
    };

    const fullPath = generatePath(pathTemplate, params);
    navigate(fullPath);
  };

  const showSelectAll =
    props.userRole === UserRoles.APPROVER &&
    props.propertyInfo?.status === Statuses.SUBMITTEDFORAPPROVAL &&
    !isRequestForChange;

  const shouldShowEditColumn =
    (props.userRole === UserRoles.INSPECTOR &&
      props.inspectorInspectionStatus !== Statuses.COMPLETED &&
      (props.propertyInfo?.status === Statuses.REJECTED ||
        props.propertyInfo?.status === Statuses.INREVIEW ||
        props.propertyInfo?.status === Statuses.INPROGRESS)) ||
    (props.userRole === UserRoles.INSPECTOR &&
      props.propertyInfo?.status === Statuses.SUBMITTEDFORAPPROVAL &&
      isRequestForChange) ||
    (props.userRole === UserRoles.INSPECTOR &&
      props.propertyInfo?.status === Statuses.REJECTED &&
      isRequestForChange);
  const showViewColumns = [
    {
      field: "view",
      height: 50,
      headerName: "View",
      headerClassName: "super-app-theme--header",
      editable: false,
      sortable: false,
      filterable: false,
      flex: 1,
      type: "string",
      renderCell: (data) => {
        return (
          <>
            <i
              className="fa-solid fa-eye fa-lg"
              title="View"
              style={{ cursor: "pointer", justifyItems: "center" }}
              onClick={() => {
                gotoDashBoard(data?.row?.doorRefNumber, "view");
              }}
            ></i>
          </>
        );
      },
    },
    {
      field: "Audit_Trail",
      height: 50,
      headerName: "Audit_Trail",
      headerClassName: "super-app-theme--header",
      editable: false,
      sortable: false,
      filterable: false,
      flex: 1,
      type: "string",
      renderCell: (data) => {
        return (
          <>
           <HistoryIcon fontSize="small" 
              className="fa-solid fa-eye fa-lg"
              title="Audit_Trail"
              style={{ cursor: "pointer", justifyItems: "center" }}
              onClick={() => {
                gotoAuditScreen(data?.row?.doorRefNumber, "Audit_Trail");
              }}
          />
          </>
        );
      },
    },
    {
      field: "status",
      headerName: "Door Status",
      width: 220,
      height: 50,
      headerClassName: "super-app-theme--header",
      editable: false,
      type: "string",
      minWidth: 200,
      flex: 1,
    },
    {
      field: "doorRefNumber",
      headerName: "Door Reference",
      width: 220,
      height: 50,
      headerClassName: "super-app-theme--header",
      editable: false,
      type: "string",
      minWidth: 200,
      flex: 1,
    },
    {
      field: "doorType",
      headerName: "Type",
      width: 180,
      height: 50,
      headerClassName: "super-app-theme--header",
      editable: false,
      type: "string",
      minWidth: 180,
      flex: 1,
    },
    {
      field: "fireRating",
      headerName: "Fire Rating",
      width: 180,
      height: 50,
      headerClassName: "super-app-theme--header",
      editable: false,
      type: "string",
      minWidth: 180,
      flex: 1,
      renderCell: (data) => {
        return (
          <>
            {data?.row?.fireRating === "Select" ? "-" : data?.row?.fireRating}
          </>
        );
      },
    },
    {
      field: "compliance",
      width: 180,
      height: 50,
      headerName: "Compliant",
      headerClassName: "super-app-theme--header",
      editable: false,
      type: "string",
      minWidth: 180,
      flex: 1,
      renderCell: (data) => {
        return (
          <>
            <span
              className={
                data?.row?.compliance === "Compliant"
                  ? "status-dot-green"
                  : "status-dot-orange"
              }
            ></span>
            {data?.row?.compliance}
          </>
        );
      },
    },
    {
      field: "comments",
      width: 180,
      height: 50,
      headerName: "Comments",
      headerClassName: "super-app-theme--header",
      editable: false,
      minWidth: 180,
      flex: 1,
      type: "string",
      renderCell: (data) => {
        return <>{data?.row?.comments || "-"}</>;
      },
    },
    // {
    //   field: "view",
    //   width: 70,
    //   height: 50,
    //   headerName: "View",
    //   headerClassName: "super-app-theme--header",
    //   editable: false,
    //   sortable: false,
    //   filterable:false,
    //   minWidth: 70,
    //   flex: 1,
    //   type: "string",
    //   renderCell: (data) => {
    //     return (
    //       <>
    //         <i
    //           className="fa-solid fa-eye fa-lg"
    //           title="View"
    //           style={{ cursor: "pointer", justifyItems: "center" }}
    //           onClick={() => {
    //             gotoDashBoard(data?.row?.doorRefNumber, "view");
    //           }}
    //         ></i>
    //       </>
    //     );
    //   },
    // },
  ];
  const showEditColumns = [
    {
      field: "view",
      width: 70,
      height: 50,
      headerName: "View",
      headerClassName: "super-app-theme--header",
      filterable: false,
      disableColumnMenu: true,
      editable: false,
      sortable: false,
      minWidth: 70,
      flex: 1,
      type: "string",
      renderCell: (data) => {
        return (
          <>
            <i
              className="fa-solid fa-eye fa-lg"
              title="View"
              style={{ cursor: "pointer", justifyItems: "center" }}
              onClick={() => {
                gotoDashBoard(data?.row?.doorRefNumber, "view");
              }}
            ></i>
          </>
        );
      },
    },
    {
      field: "edit",
      height: 50,
      headerName: "Edit",
      sortable: false,
      type: "string",
      headerClassName: "super-app-theme--header",
      editable: false,
      filterable: false,
      renderCell: (data) => {
        let isEdit;
        if (
          data?.row?.status === Statuses.REQUESTFORCHANGE ||
          data?.row?.status === Statuses.PENDINGFORAPPROVAL
        ) {
          isEdit = true;
        } else {
          isEdit = false;
        }
        return (
          <>
            <i
              className="fa-solid fa-pen-to-square fa-lg"
              title="Edit"
              style={
                isEdit === true ? { cursor: "pointer" } : { display: "none" }
              }
              onClick={() => {
                gotoDashBoard(data?.row?.doorRefNumber, "edit");
              }}
            ></i>
          </>
        );
      },
    },
    {
      field: "status",
      headerName: "Door Status",
      width: 220,
      height: 50,
      headerClassName: "super-app-theme--header",
      editable: false,
      type: "string",
      minWidth: 200,
      flex: 1,
    },
    {
      field: "doorRefNumber",
      headerName: "Door Reference",
      width: 220,
      height: 50,
      headerClassName: "super-app-theme--header",
      editable: false,
      type: "string",
      minWidth: 200,
      flex: 1,
    },
    {
      field: "doorType",
      headerName: "Type",
      width: 180,
      height: 50,
      headerClassName: "super-app-theme--header",
      editable: false,
      type: "string",
      minWidth: 180,
      flex: 1,
    },
    {
      field: "fireRating",
      headerName: "Fire Rating",
      width: 180,
      height: 50,
      headerClassName: "super-app-theme--header",
      editable: false,
      type: "string",
      minWidth: 180,
      flex: 1,
      renderCell: (data) => {
        return (
          <>
            {data?.row?.fireRating === "Select" ? "-" : data?.row?.fireRating}
          </>
        );
      },
    },
    {
      field: "compliance",
      width: 180,
      height: 50,
      headerName: "Compliant",
      headerClassName: "super-app-theme--header",
      editable: false,
      type: "string",
      minWidth: 180,
      flex: 1,
      renderCell: (data) => {
        return (
          <>
            <span
              className={
                data?.row?.compliance === "Compliant"
                  ? "status-dot-green"
                  : "status-dot-orange"
              }
            ></span>
            {data?.row?.compliance}
          </>
        );
      },
    },
    {
      field: "comments",
      width: 230,
      height: 50,
      headerName: "Comments",
      headerClassName: "super-app-theme--header",
      editable: false,
      minWidth: 180,
      flex: 1,
      type: "string",
      renderCell: (data) => {
        return <>{data?.row?.comments || "-"}</>;
      },
    },
  ];
  const bookingColumns = [
    {
      field: "bookingId",
      headerName: "Booking ID",
      width: 180,
      height: 50,
      headerClassName: "super-app-theme--header",
      editable: false,
      type: "string",
      minWidth: 180,
      flex: 0.5,
    },
    {
      field: "customerName",
      headerName: "Customer Name",
      width: 100,
      height: 50,
      headerClassName: "super-app-theme--header",
      editable: false,
      type: "string",
      minWidth: 100,
      flex: 0.8,
    },
    {
      field: "emailAddress",
      headerName: "Customer Email",
      width: 220,
      height: 50,
      headerClassName: "super-app-theme--header",
      editable: false,
      type: "string",
      minWidth: 220,
      flex: 1,
    },
    {
      field: "mobileNo",
      headerName: "Mobile Number",
      width: 100,
      height: 50,
      headerClassName: "super-app-theme--header",
      editable: false,
      type: "string",
      minWidth: 100,
      flex: 0.7,
    },
    {
      field: "inspector",
      headerName: "Inspector",
      width: 180,
      height: 50,
      headerClassName: "super-app-theme--header",
      editable: false,
      type: "string",
      minWidth: 180,
      flex: 0.7,
    },
    {
      field: "status",
      headerName: "Status",
      width: 100,
      height: 50,
      headerClassName: "super-app-theme--header",
      editable: false,
      type: "string",
      minWidth: 100,
      flex: 0.5,
    },
    {
      field: "bookedDateTime",
      headerName: "Booked Date & Time",
      width: 180,
      height: 50,
      headerClassName: "super-app-theme--header",
      editable: false,
      type: "string",
      minWidth: 180,
      flex: 0.8,
      valueGetter: (params) => {
        return params.replace(" ", " - ");
      },
    },

    {
      field: "address",
      headerName: "Address",
      width: 180,
      height: 50,
      headerClassName: "super-app-theme--header",
      editable: false,
      type: "string",
      minWidth: 180,
      flex: 1,
    },
  ];
  // Column definitions
  const getResidentTableColumns = () => [
    // { field: "firstName", headerName: "NAME", flex: 1, headerClassName: "header-bold" },
    {
      field: "name",
      headerName: "Name",
      headerClassName: "header-bold super-app-theme--header",
      sortable: false,
      flex: 1,
      renderCell: (params) => `${params.row.firstName}  ${params.row.lastName}`,
    },
    {
      field: "email",
      headerName: "EMAIL",
      flex: 1,
      headerClassName: "header-bold super-app-theme--header",
    },
    {
      field: "phoneNumber",
      headerName: "PHONE NO.",
      flex: 1,
      headerClassName: "header-bold super-app-theme--header",
    },
    {
      field: "propertyDetails",
      headerName: "PROPERTY DETAILS",
      headerClassName: "header-bold super-app-theme--header",
      sortable: false,
      flex: 2,
      renderCell: (params) =>
        `${params.row.propertyName}, ${params.row.apartmentOrHouseNo},${params.row.propertyAddress}, ${params.row.city}, ${params.row.postCode}`,
    },
    {
      field: "actions",
      headerName: "ACTIONS",
      headerClassName: "header-bold super-app-theme--header",
      sortable: false,
      flex: 0.7,
      renderCell: (params) => (
        <Box>
          <i
            className="fa fa-regular fa-file-text vividOrangeColor px-2"
            title="Generate Letter"
            style={{ cursor: "pointer", justifyItems: "center" }}
            onClick={() => {
              // gotoDashBoard(data?.row?.doorRefNumber, "view");
            }}
          ></i>
          <i
            className="fa fa-regular fa-envelope vividOrangeColor px-2"
            title="Send Email"
            style={{ cursor: "pointer", justifyItems: "center" }}
            onClick={() => {
              props.setSelectedIds([params.row.rmsUserInfoId]);
              props.setShowEmailConfirmation(true);
            }}
          ></i>
        </Box>
      ),
    },
  ];
    const paginatedRows = userList?.slice(
    page * pageSize,
    page * pageSize + pageSize
  );
  const handleRowSelectionChange = (
    selectionModel,
    userList,
    setSelectedIds,
    module
  ) => {
    const selectedIds = Array.from(selectionModel?.ids || []);

    if (module === "leadDashboard") {
      if (selectionModel.type === "include") {
        setSelectedIds(selectedIds);
      } else if (selectionModel.type === "exclude") {
        if (selectedIds.length === 0) {
          const allIds = userList.map((row) => row.rmsUserInfoId);
          setSelectedIds(allIds);
        } else {
          setSelectedIds((prev) =>
            prev.filter((id) => !selectedIds.includes(id))
          );
        }
      }
    } else {
      // Default behavior for other modules
      const selectionArray = Array.isArray(selectionModel)
        ? selectionModel
        : Array.from(selectionModel?.ids ?? []);
      setSelectedRows(selectionArray);
      // setSelectedIds(selectedIds);
    }
  };
  const handleFilterModelChange = React.useCallback(
    (newModel) => {
      setFilterModel(newModel);
      if (props.onFilteredRowsChange) {
        let filtered = userList;
        newModel.items.forEach((filter) => {
          if (filter.value && filter.field) {
            filtered = filtered.filter((row) => {
              const cellValue = String(row[filter.field] ?? "").toLowerCase();
              const filterValue = String(filter.value).trim().toLowerCase();

              switch (filter.operator) {
                case "equals":
                  return cellValue === filterValue;
                case "doesNotEqual":
                case "notEquals":
                  return cellValue !== filterValue;
                case "contains":
                  return cellValue.includes(filterValue);
                case "doesNotContain":
                  return !cellValue.includes(filterValue);
                case "startsWith":
                  return cellValue.startsWith(filterValue);
                case "endsWith":
                  return cellValue.endsWith(filterValue);
                case "isEmpty":
                  return cellValue === "";
                case "isNotEmpty":
                  return cellValue !== "";
                case "isAnyOf":
                  return filterValue
                    .split(",")
                    .some((val) => cellValue.includes(val.trim()));
                default:
                  // fallback to contains
                  return cellValue.includes(filterValue);
              }
            });
          }
        });
        props.onFilteredRowsChange(filtered);
      }
    },
    [userList, props.onFilteredRowsChange]
  );
  // const isToolbarSelectRef = React.useRef(false);

  const allSelected =
    userList.length > 0 && selectedRows.length === userList.length;

  // Synchronize DataGrid selection with custom logic
  // const handleSelectionModelChange = (newSelection) => {
  //   const selectionArray = Array.isArray(newSelection)
  //     ? newSelection
  //     : Array.from(newSelection?.ids ?? []);
  //   setSelectedRows(selectionArray);
  // };

  return (
    <Box sx={{ width: "100%" }}>
      <DataGrid
        filterModel={filterModel}
        showToolbar={props.module == "leadDashboard" ? false : true}
        rows={paginatedRows}
        loading={loading}
        columns={
          props.module == "leadDashboard"
            ? getResidentTableColumns(
                props.setSelectedIds,
                props.setShowEmailConfirmation
              )
            : props.IsBookingSurveyGrid
            ? bookingColumns
            : shouldShowEditColumn
            ? showEditColumns
            : showViewColumns
        }
        checkboxSelection={
          props.module == "leadDashboard" ? true : showSelectAll
        }
        disableRowSelectionOnClick={
          props.module == "leadDashboard" ? true : false
        }
        onRowSelectionModelChange={(selectionModel) =>
          handleRowSelectionChange(
            selectionModel,
            userList,
            props.setSelectedIds,
            props.module
          )
        }
        getRowId={(row) =>
          props.module == "leadDashboard" ? row.rmsUserInfoId : row.id
        }
        getRowClassName={(params) =>
          params.indexRelativeToCurrentPage % 2 === 0 ? "even-row" : "odd-row"
        }
        rowHeight={45}
        columnHeaderHeight={45}
        slots={{
          toolbar: () => (
            <CustomToolbar
              allSelected={allSelected}
              onApproveAll={() => props.onApproveAllButton()}
              showSelectAll={showSelectAll}
            />
          ),
        }}
        pageSize={pageSize || 10}
        pageSizeOptions={[5, 10, 20, { value: -1, label: "All" }]}
        sx={{
          display: "grid",
          boxShadow: 2,
          width: "100%",
          ...gridStyles,
        }}
        initialState={{
          pagination: { paginationModel: { pageSize: pageSize || 10 } },
        }}
        disableColumnMenu
        onFilterModelChange={handleFilterModelChange}
      />
      <CustomPagination
        rowCount={userList?.length}
        page={page}
        pageSize={pageSize}
        onPageChange={setPage}
      />
    </Box>
  );
}
